import React, { useState } from "react";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Swal from "sweetalert2";
import { sendContactUsMessage } from "../../../api/apiHandler";

const ContactPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { name, email, message };
    sendContactUsMessage(data).then((response) => {
      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
        setName("");
        setEmail("");
        setMessage("");
      } else {
        console.log("errors--------", response);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: response.message,
          toast: true,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    });
  };

  return (
    <>
      <main className="bg-color">
        <Header />
        <section className="heading-section">
          <div className="">
            <p className=" font_54 text-white font_500 text-center">
              Contact Us
            </p>
            {/* <h4 className="m-0 fw-bold text-white">monteserenohealth.org</h4> */}
          </div>
        </section>
        <ContactSec className="position-relative">
          <div className="container-fluid">
            <Row className="align-items-center">
              <Col lg="6" className="my-2">
                <div className="text-center">
                  <div className="py-3">
                    <h6 className="m-0 pb-2 fw-bold text-muted">Contact Us</h6>
                    <ul className="list-unstyled ps-0 mb-0">
                      <li className="d-flex align-items-center gap-10  py-2 justify-content-center">
                        <span>General Inquiries: </span>
                        <Link to={""} className="themeClr">
                          test.mgr@monteserenohealth.com
                        </Link>
                      </li>
                      {/* <li className="d-flex align-items-center gap-10  py-2 justify-content-center">
                        <span>Investment Inquiries: </span>
                        <Link to={""} className="themeClr">
                          Info@gmail.com
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                  {/* <div className="py-3">
                    <h6 className="m-0 pb-2 fw-bold text-muted">
                      UB VENTURES. LLC
                    </h6>
                    <p className="m-0 py-2">
                      50 Milk Street , Boston, MA , USA
                    </p>
                  </div> */}
                  <div className="py-2 mt-5">
                    <button className="fw-bold bg-transparent border-0 p-0 text-muted">
                      CONNECT WITH US
                    </button>
                  </div>
                </div>
              </Col>
              <Col
                lg="6"
                className="my-2 position-relative imgWrpper"
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/about-us-img--1.jpg)`,
                  backgroundSize: "cover",
                }}
              >
                <div className="p-lg-5 p-3 text-white">
                  <div className="top pb-3 text-center">
                    <h3 className="m-0 fw-bold">Get in touch</h3>
                    {/* <p className="m-0 py-1">We are in San Diegol Say Hi</p> */}
                    {/* <p className="m-0 py-1">monteserenohealth.org</p> */}
                  </div>
                  <div className="formBody">
                    <form action="">
                      <div className="py-2">
                        <label htmlFor="" className="m-0">
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                      <div className="py-2">
                        <label htmlFor="" className="m-0">
                          Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="py-2">
                        <label htmlFor="" className="m-0">
                          Message
                        </label>
                        <textarea
                          name="message"
                          rows={5}
                          className="form-control"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                        ></textarea>
                      </div>
                      <div className="py-2">
                        <div className="text-center">
                          <button
                            disabled={
                              !name.trim() || !email.trim() || !message.trim()
                            }
                            className="d-inline-flex align-items-center justify-content-center commonBtn btn rounded-pill"
                            onClick={handleSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </ContactSec>
        <Footer />
      </main>
    </>
  );
};

const ContactSec = styled.div`
  .imgWrpper {
    z-index: 9;
    &:after {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      background: #000;
      z-index: -9;
      opacity: 0.6;
    }
  }
`;

export default ContactPage;
